import { render, staticRenderFns } from "./labelsConfig.vue?vue&type=template&id=03cdc968&scoped=true"
import script from "./labelsConfig.vue?vue&type=script&lang=js"
export * from "./labelsConfig.vue?vue&type=script&lang=js"
import style0 from "./labelsConfig.vue?vue&type=style&index=0&id=03cdc968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cdc968",
  null
  
)

export default component.exports